<section *ngIf="dataGross.success && shouldShowHistoricalPerformance" class="bfa-component-wrapper">
	<h3>
		<span class="icon-caption title-main" dcrHTMLKey="HISTORICAL_PERFORMANCE">Historical Returns vs Risk</span>
		<icon type="info-circle" class="info-circle text-14 color-primary" *ngIf="tooltipText" [tooltip]="infoBubble"> </icon>
	</h3>
	<ng-template #infoBubble> <section [innerHTML]="tooltipText"></section> </ng-template>
	<ng-container *ngIf="dataGross.tabs.length; else lessThanOneYear">
		<div class="row row-margin-override">
			<div class="col-12 align-items-center">
				<label *ngIf="asOfDate">
					<h3 class="text-16 margin-bottom-30">
						<span dcrHTMLKey="AS_OF_DATE_DYNAMIC" [dcrSubstitutions]="{ $asOfDate$: asOfDate }" data-cy="historical-performance-as-of-date">As of $asOfDate$</span>
					</h3>
				</label>
			</div>
			<div class="col-12 d-flex justify-content-right align-items-center custom-controls" *ngIf="showCustomAdvisoryFeeButton">
				<div *ngIf="isCustomFeeEnabled" [ngClass]="hasBenchmarkPortfolio ? 'padding-right-25' : ''">
					<cfe-custom-advisory-fee-dialog-button id="pa-custom-fee-dialog" [customAdvisoryFee]="customAdvisoryFee"></cfe-custom-advisory-fee-dialog-button>
				</div>
				<div *ngIf="hasBenchmarkPortfolio" class="col-10 ac-dropdown custom-dropdown">
					<div class="capture-ratio-vs" dcrHTMLKey="CAPTURE_RATIO_VS">Capture Ratio vs</div>
					<select (change)="onBenchmarkOptionChange()" [(ngModel)]="selectedBenchmarkForCaptureRatio">
						<option *ngFor="let benchmarkOption of benchmarkOptions | keyvalue" [value]="benchmarkOption?.value">
							{{ benchmarkOption?.value | dcr : 'CAPTURE_RATIO_OPTION_' + benchmarkOption?.key }}
						</option>
					</select>
				</div>
			</div>
		</div>
		<bfa-accordion>
			<bfa-tabs type="underline" custom-classes="tabs-performance" [hideTabBarIfOneTab]="hideTabBarIfOneTab" (activeTabPanelChange)="onTabClick($event?.index)">
				<ng-container *ngFor="let tab of dataGross.tabs; index as tabIndex">
					<ng-container *ngIf="!tab.error && tab.config.id !== 'hypo-perf-as-of-date'">
						<ng-template #tabItem>
							<dcr-cell-content [config]="tab.config.title"></dcr-cell-content>
							<ng-container *ngIf="shouldShowCommonPeriodInfo">
								<ng-container *ngIf="tabIndex === 0">
									<span
										*ngIf="tab.tableData[0] && tab.tableData[0].cells[0] && tab.tableData[0].cells[0][0] && tab.tableData[0].cells[0][1]"
										class="text-sm-14-medium as-of-date"
									>
										{{ getCellValueById('startDate', tab) }} - {{ getCellValueById('endDate', tab) }}
									</span>
									<p dcrHTMLKey="HISTORICAL_PERFORMANCE_COMMON_PERIOD_MESSAGE" class="text-16 margin-vertical-5">
										The historical period for which returns are available for all holdings. The common period begins at the inception date of the newest funds
										or share class.
									</p>
									<p class="text-16-bold margin-bottom-20">
										<ac-cta-link
											(click)="isCommonPeriodModalVisible = true"
											icon="arrow-right"
											class="text-16-bold"
											trackEvent="historical performance:common period dialog"
										>
											<span dcrHTMLKey="DEFINING_COMMON_PERIOD"> What is defining the common period? </span>
										</ac-cta-link>
									</p>
								</ng-container>
							</ng-container>
							<label></label>
							<div *ngIf="tab.tableData">
								<div class="margin-standard">
									<ac-combined-data-table
										[tabs]="currentTabs"
										[excludeColumns]="columnConfigIds"
										[columnWidths]="columnWidths"
										[isStriped]="true"
										[isBordered]="true"
										[isPadded]="true"
									></ac-combined-data-table>
								</div>
								<!-- TODO wkennerl: update this check -->
								<div *ngIf="combinedData && showChart" class="margin-standard row">
									<div *ngIf="isCustomFeeEnabled" class="col-6">
										<perf-performance-chart-grouped-legend
											[chartData]="combinedData[tabIndex]"
											[groupingConfiguration]="groupedLegendColumnConfiguration"
											[seriesColors]="groupedLegendColours"
											[seriesLabelIcon]="seriesIcon.CIRCLE"
										></perf-performance-chart-grouped-legend>
									</div>
									<div [ngClass]="chartColClass">
										<bfa-chart
											[data]="combinedData[tabIndex]"
											[type]="ChartType.Scatter"
											[height]="400"
											[customAttributes]="scatterChartAttributes"
										></bfa-chart>
									</div>
								</div>
							</div>
							<ac-disclosure [isExpandable]="false">
								<section *ngIf="isCustomFeeEnabled && !customAdvisoryFee" dcrHTMLKey="NO_NET_PERF_DISCLOSURE">NO_NET_PERF_DISCLOSURE</section>
								<section dcrHTMLKey="HISTORICAL_PERFORMANCE_DISCLAIMER" data-cy="historical-performance-disclosure">HISTORICAL_PERFORMANCE_DISCLAIMER</section>
								<section *ngIf="displayISOCurrency">
									<section dcrHTMLKey="PERFORMANCE_SOURCE">Source: Morningstar, Refinitive and BlackRock Aladdin</section>
									<section>
										<span dcrHTMLKey="AS_OF_DATE" data-cy="historical-performance-source-as-of-date">As of: {{ asOfDate }}</span>
										<span dcrHTMLKey="CURRENCY"> Currency: {{ displayISOCurrency }} </span>
										<span dcrHTMLKey="PERFORMANCE_POST_DISCLOSURE_TEXT">, performance is net of fees</span>
									</section>
								</section>
							</ac-disclosure>
							<br />
						</ng-template>
						<tab-panel [tab-title]="tab.config.title.label" [templateRef]="tabItem"></tab-panel>
					</ng-container>
				</ng-container>
			</bfa-tabs>
		</bfa-accordion>
	</ng-container>
	<ng-template #lessThanOneYear>
		<section class="disclaimer-container margin-standard" dcrHTMLKey="COMMON_PERIOD_LESS_THAN_ONE_YEAR">COMMON_PERIOD_LESS_THAN_ONE_YEAR</section>
		<p class="text-16-bold margin-bottom-20">
			<ac-cta-link (click)="isCommonPeriodModalVisible = true" class="text-16-bold" icon="arrow-right" trackEvent="historical performance:common period dialog">
				<span dcrHTMLKey="DEFINING_COMMON_PERIOD"> What is defining the common period? </span>
			</ac-cta-link>
		</p>
	</ng-template>
	<section *ngIf="showSectionSeparator" class="section-separator"></section>
</section>

<bfa-modal [(isVisible)]="isCommonPeriodModalVisible" [enableClose]="true" [enableBackdrop]="true" width="980px">
	<perf-common-period *componentId="'performance.common.period'; let res" [data]="res"></perf-common-period>
</bfa-modal>
